import Store from './Store';
import { buildModels } from '../libraries/graphql';


export default class DraftParent extends Store {
  store = {
    parentId: null,
    parentType: null, 
    prompt: null
  }

  constructor(props) {
    super(props);
    this.set(props);
    return this.setup();
  }

  static isDraftParent(obj) {
    return obj instanceof DraftParent; 
  }
}


// Build Graphhql model
buildModels(DraftParent);



// WEBPACK FOOTER //
// ./src/models/DraftParent.js